/** "2,500". */
export const formatCount = new Intl.NumberFormat('en-US').format;

const pluralRules = new Intl.PluralRules('en-US');

/** "1 day", "0 items", "1,000 typical notes": the grouped count with the noun in its en-US form. */
export const pluralize = (count: number, singular: string, plural = `${singular}s`) =>
  `${formatCount(count)} ${pluralNoun(count, singular, plural)}`;

/** "day" for 1, "days" otherwise: the noun alone, for layouts that style the count and the noun separately. */
export const pluralNoun = (count: number, singular: string, plural = `${singular}s`) =>
  pluralRules.select(count) === 'one' ? singular : plural;
